import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
// Not signed in → login, then back to the page they asked for (deep links from messages keep working).
const ProtectedPage = ({ children, isLoggedIn }) => {
    const location = useLocation();
    const back = `${location.pathname}${location.search}`;
    return (
        isLoggedIn ? children : <Navigate to={`/login?redirect=${encodeURIComponent(back)}`} replace />
    )
}

const mapStateToProps = state => ({
    isLoggedIn: state.customerPage.isLoggedIn
});

export const ProtectedRoute = connect(mapStateToProps, {})(ProtectedPage);